export default __webpack_public_path__ + "static/media/Screenshot (1134).d1181efb.png";